export const SVG_MODELS = {
    chair_1:
        '<g>\n' +
        '  <path d="M47.5 7.5L0.5 7.5L0.5 0.499998L47.5 0.5L47.5 7.5Z" fill="white" stroke="black"/>' +
        '  <mask id="path-2-inside-1_7188_1305" fill="white">\n' +
        '       <path d="M48 8L48 40C48 44.4183 44.4183 48 40 48L8 48C3.58172 48 -1.59189e-06 44.4183 -1.39876e-06 40L0 8L48 8Z"/>' +
        '  </mask>' +
        '  <path d="M48 8L48 40C48 44.4183 44.4183 48 40 48L8 48C3.58172 48 -1.59189e-06 44.4183 -1.39876e-06 40L0 8L48 8Z" fill="white"/>' +
        '  <path d="M49 8L49 40C49 44.9706 44.9706 49 40 49L40 47C43.866 47 47 43.866 47 40L47 8L49 8ZM8 49C3.02944 49 -1 44.9706 -1 40L-1 8L1 8L0.999999 40C0.999998 43.866 4.13401 47 8 47L8 49ZM0 8L48 8L0 8ZM49 40C49 44.9706 44.9706 49 40 49L8 49C3.02944 49 -1 44.9706 -1 40L0.999999 40C0.999998 43.866 4.13401 47 8 47L40 47C43.866 47 47 43.866 47 40L49 40Z" fill="black" mask="url(#path-2-inside-1_7188_1305)"/>' +
        '</g>',
    vip_chair_1:
        '<g>\n' +
        '  <path d="M58 38L55 38L55 0.999999L63 1L63 33C63 35.7614 60.7614 38 58 38Z" fill="white" stroke="black" stroke-width="2"/>' +
        '  <path d="M6 38C3.23858 38 1 35.7614 1 33L1 0.999999L9 1L9 38L6 38Z" fill="white" stroke="black" stroke-width="2"/>' +
        '  <mask id="path-3-inside-1_7425_1546" fill="white">' +
        '  <path d="M56 5.99997L56 40C56 44.4182 52.4183 48 48 48L16 48C11.5817 48 8 44.4182 8 40L8 5.99997L56 5.99997Z"/>' +
        '  </mask>' +
        '  <path d="M56 5.99997L56 40C56 44.4182 52.4183 48 48 48L16 48C11.5817 48 8 44.4182 8 40L8 5.99997L56 5.99997Z" fill="white"/>' +
        '  <path d="M58 5.99997L58 40C58 45.5228 53.5228 50 48 50L48 46C51.3137 46 54 43.3137 54 40L54 5.99997L58 5.99997ZM16 50C10.4772 50 6 45.5228 6 40L6 5.99997L10 5.99997L10 40C10 43.3137 12.6863 46 16 46L16 50ZM8 5.99997L56 5.99997L8 5.99997ZM58 40C58 45.5228 53.5228 50 48 50L16 50C10.4772 50 6 45.5228 6 40L10 40C10 43.3137 12.6863 46 16 46L48 46C51.3137 46 54 43.3137 54 40L58 40Z" fill="#black" mask="url(#path-3-inside-1_7425_1546)"/>' +
        '  <path d="M55 3.99997C55 6.76139 52.7614 8.99997 50 8.99997L14 8.99997C11.2386 8.99997 9 6.76139 9 3.99997L9 0.99997L55 0.999969L55 3.99997Z" fill="white" stroke="black" stroke-width="2"/>' +
        '</g>',
    table_1:
        '<g fill="none">\n' +
        '  <rect x="0.5" y="0.5" width="263" height="87" fill="white"/>' +
        '  <rect x="0.5" y="0.5" width="263" height="87" stroke="black"/>' +
        '</g>',
    table_2:
        '<g fill="none">\n' +
        '  <rect x="0.5" y="0.5" width="175" height="87" fill="white"/>' +
        '  <rect x="0.5" y="0.5" width="175" height="87" stroke="black"/>' +
        '</g>',
    table_3:
        '<g fill="none">\n' +
        '  <rect x="0.5" y="0.5" width="87" height="87" fill="white"/>' +
        '  <rect x="0.5" y="0.5" width="87" height="87" stroke="black"/>' +
        '</g>',
    table_4:
        '<g fill="none">\n' +
        '  <rect x="0.5" y="0.5" width="175" height="175" rx="87.5" fill="white"/>' +
        '  <rect x="0.5" y="0.5" width="175" height="175" rx="87.5" stroke="black" />' +
        '</g>',
    table_5:
        '<g fill="none">\n' +
        '  <rect x="0.5" y="0.5" width="103" height="103" rx="51.5" fill="white"/>' +
        '  <rect x="0.5" y="0.5" width="103" height="103" rx="51.5" stroke="black" /> ' +
        '</g>',
    table_6:
        '<g fill="none">\n' +
        '  <rect x="0.5" y="0.5" width="87" height="87" rx="43.5" fill="white"/>' +
        '  <rect x="0.5" y="0.5" width="87" height="87" rx="43.5" stroke="black"/>' +
        '</g>',
    stage:
        '<g fill="none">\n' +
        '  <rect x="0.5" y="0.5" width="199" height="99" fill="white"/>' +
        '  <rect x="0.5" y="0.5" width="199" height="99" stroke="black"/>' +
        '</g>',
    // Wide label model for stages, buffets, and other wide decorative elements
    label_wide:
        '<g fill="none">\n' +
        '  <rect x="0.5" y="0.5" width="399" height="49" fill="white"/>' +
        '  <rect x="0.5" y="0.5" width="399" height="49" stroke="black"/>' +
        '</g>',
    // Vertical table models for FH seat map import (1 grid unit wide, variable height)
    table_v_4:
        '<g fill="none">\n' +
        '  <rect x="0.5" y="0.5" width="39" height="159" fill="white"/>' +
        '  <rect x="0.5" y="0.5" width="39" height="159" stroke="black"/>' +
        '</g>',
    table_v_6:
        '<g fill="none">\n' +
        '  <rect x="0.5" y="0.5" width="39" height="239" fill="white"/>' +
        '  <rect x="0.5" y="0.5" width="39" height="239" stroke="black"/>' +
        '</g>',
    table_v_9:
        '<g fill="none">\n' +
        '  <rect x="0.5" y="0.5" width="39" height="359" fill="white"/>' +
        '  <rect x="0.5" y="0.5" width="39" height="359" stroke="black"/>' +
        '</g>',
};

// precalculate viewBoxes for each SVG model
export const SVG_WRAPPERS = {
    chair_1: `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" >{{SVG_CONTENT}}</svg>`,
    vip_chair_1: `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="48" viewBox="0 0 64 48" >{{SVG_CONTENT}}</svg>`,
    table_1: `<svg xmlns="http://www.w3.org/2000/svg" width="264" height="88" viewBox="0 0 264 88">{{SVG_CONTENT}}</svg>`,
    table_2: `<svg xmlns="http://www.w3.org/2000/svg" width="176" height="88" viewBox="0 0 176 88">{{SVG_CONTENT}}</svg>`,
    table_3: `<svg xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88">{{SVG_CONTENT}}</svg>`,
    table_4: `<svg xmlns="http://www.w3.org/2000/svg" width="176" height="176" viewBox="0 0 176 176">{{SVG_CONTENT}}</svg>`,
    table_5: `<svg xmlns="http://www.w3.org/2000/svg" width="104" height="104" viewBox="0 0 104 104">{{SVG_CONTENT}}</svg>`,
    table_6: `<svg xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88">{{SVG_CONTENT}}</svg>`,
    stage: `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="100" viewBox="0 0 200 100">{{SVG_CONTENT}}</svg>`,
    label_wide: `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="50" viewBox="0 0 400 50">{{SVG_CONTENT}}</svg>`,
    table_v_4: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="160" viewBox="0 0 40 160">{{SVG_CONTENT}}</svg>`,
    table_v_6: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="240" viewBox="0 0 40 240">{{SVG_CONTENT}}</svg>`,
    table_v_9: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="360" viewBox="0 0 40 360">{{SVG_CONTENT}}</svg>`,
};
